import React, { useState } from "react";
import "./Common_Expert_Card.css";
import Common_Send_Button from "../common-send-button/Common_Send_Button";
import Common_Call_Button from "../common-send-button/common-call-button/Common_Call_Button";
import { IDS } from "../../../utils/IDS";
import Send_Btn_Expert_Modal from "../common-modals/send-btn-expert-modal/Send_Btn_Expert_Modal";
import Call_Now_Expert_Modal from "../common-modals/call-now-expert-modal/Call_Now_Expert_Modal";
import Subscription_Needed_Lottie_Modal from "../subscription-needed-lottie-modal/Subscription_Needed_Lottie_Modal";
import { useNavigate } from "react-router-dom";

const Common_Expert_Card = ({ expert, onClick3, onClick4 }) => {
  console.log(expert, "vvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvv");
  const navigate = useNavigate();

  const [showInquiry, setShowInquiry] = useState(false);
  const [showCall, setShowCall] = useState(false);
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const handleInquiryClick = (type) => {
    if (type === "NO_SUBSCRIPTION") {
      setShowSubscriptionModal(true);
      return;
    }
    setShowInquiry(true);
  };

  const handleCallClick = (type) => {
    if (type === "NO_SUBSCRIPTION") {
      setShowSubscriptionModal(true);
      return;
    }
    setShowCall(true);
  };
  if (!expert) return null;

  const user = expert.user || {};
  const userDetails = user.user_details || {};

  const professionNames =
    userDetails.profession
      ?.map((p) => p.profession?.name)
      .filter(Boolean)
      .join(", ") || "N/A";

  const img = user.profile_pic
    ? `${IDS.IMG_URL}${user?.profile_pic}`
    : "/assets/images/banner/banner.png";

  // Verified status
  const verified = user?.verify_status;

  // Calculate age from dob
  const age = userDetails?.dob
    ? new Date().getFullYear() - new Date(userDetails?.dob).getFullYear()
    : "N/A";

  return (
    <>
      <div className="profile-card-wrapper">
        <div className="profile-card-body">
          {/* Profile Image */}
          <div className="profile-card-image">
            <img src={img} alt={user?.name || "expert"} />
          </div>

          <div className="profile-card-info">
            {/* Name & Verified */}
            <div className="profile-card-title">
              <span className="profile-card-name">{user?.name}</span>
              {verified && (
                <img
                  src="/assets/images/verified.png"
                  alt="Verified"
                  className="profile-card-badge"
                />
              )}
            </div>

            <div className="profile-card-location">
              {[userDetails?.state?.name, userDetails?.district?.name]
                .filter(Boolean)
                .join(", ") || "N/A"}
            </div>

            {/* Details */}
            <div className="profile-card-details">
              <div className="profile-card-row">
                <span className="profile-card-label">Profession:-</span>
                <span className="profile-card-value">{professionNames}</span>
              </div>

              {/* <div className="profile-card-row">
                <span className="profile-card-label">Sub Profession:-</span>
                <span className="profile-card-value">{professionNames}</span>
              </div> */}

              <div className="profile-card-row">
                <span className="profile-card-label">Experience:-</span>
                <span className="profile-card-value">
                  {userDetails.experience || "N/A"} Years
                </span>
              </div>

              <div className="profile-card-row">
                <span className="profile-card-label">Age:-</span>
                <span className="profile-card-value">{age}</span>
              </div>

              <div className="profile-card-row">
                <span className="profile-card-label">Rating:-</span>
                <span className="profile-card-value">
                  {expert?.user?.average_expert_rating?.avg_rating
                    ? `⭐ ${Number(
                        expert.user.average_expert_rating.avg_rating,
                      ).toFixed(1)} / 5`
                    : " - "}
                </span>
              </div>
            </div>

            {/* Availability & Service */}
            <div className="status-link">
              <div
                className={`profile-card-status ${
                  user.available_today ? "available" : "not-available"
                }`}
              >
                {user.available_today ? "Available Today" : "Not Available"}
              </div>
              {/* <div className="profile-card-link">
                {user.free_site_visit ? "Free Site Visit" : "Paid Service"}
              </div> */}
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        {/* <div className="buttons">
          <Common_Send_Button onClick={() => setShowInquiry(true)} />{" "}
          <Common_Call_Button onClick4={() => setShowCall(true)} />
        </div> */}
        <div className="buttons">
          <Common_Send_Button onClick={handleInquiryClick} />

          {/* IMPORTANT: pass "vendor={expert}" */}
          <Common_Call_Button vendor={expert} onClick={handleCallClick} />
        </div>
      </div>

      {showInquiry && (
        <Send_Btn_Expert_Modal
          show={showInquiry}
          handleClose={() => setShowInquiry(false)}
          expert={expert}
        />
      )}
      <Call_Now_Expert_Modal
        show={showCall}
        handleClose={() => setShowCall(false)}
        expert={expert}
      />
      <Subscription_Needed_Lottie_Modal
        showSubscription={showSubscriptionModal}
        handleSubscriptionClose={() => {
          setShowSubscriptionModal(false);
          navigate("/wallet"); // redirect
        }}
      />
    </>
  );
};

export default Common_Expert_Card;
